import { render, staticRenderFns } from "./fileItem.vue?vue&type=template&id=63d8f028&scoped=true"
import script from "./fileItem.vue?vue&type=script&lang=js"
export * from "./fileItem.vue?vue&type=script&lang=js"
import style0 from "./fileItem.vue?vue&type=style&index=0&id=63d8f028&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8f028",
  null
  
)

export default component.exports